import React from "react";
import "./Emergency.scss";

const crisisLines = [
    {
        title: "National Suicide Prevention Lifeline",
        number: "1-800-273-8255",
    },
    {
        title: "Mobile Crisis Response through CICS",
        number: "1-844-258-8858",
    },
    {
        title: "ACCESS Domestic Violence Services",
        number: "1-855-983-4641",
    },
];

export default function Emergency() {
    const sectionStyle: React.CSSProperties = {
        backgroundImage: "url('../../emergency.jpg')",
    };

    return (
        <div className="emergency-section" style={sectionStyle}>
            <div className="emergency-content">
                <p className="emergency-label emergency-label--accent">In an Emergency</p>
                <p className="emergency-intro">
                    If you are experiencing a life-threatening emergency, feeling in deep distress, or have thoughts of hurting yourself or hurting others, please go to your nearest emergency room or call{" "}
                    <span className="emergency-accent emergency-accent--underline">988</span>{" "}
                    for emergency services.
                </p>

                <hr className="emergency-divider" />

                <h2 className="emergency-hotline-title">National Mental Health/Suicide Hotline</h2>
                <div className="emergency-available">
                    <hr className="emergency-available__line" />
                    <span className="emergency-available__text">Available 24 / 7</span>
                    <hr className="emergency-available__line" />
                </div>
                <p className="emergency-text-line">
                    Text "<span className="emergency-accent">CONNECT</span>" to <span className="emergency-accent">741-741</span>
                </p>

                <hr className="emergency-divider" />

                <p className="emergency-label">Other Crisis Lines</p>
                <div className="emergency-cards">
                    {crisisLines.map((line) => (
                        <div key={line.number} className="emergency-card">
                            <p className="emergency-card__title">{line.title}</p>
                            <p className="emergency-card__number">{line.number}</p>
                        </div>
                    ))}
                </div>

                <hr className="emergency-divider" />

                <h3 className="emergency-services-title">Health, Community, and Social Services</h3>
                <p className="emergency-services-body">
                    <span className="emergency-accent">2-1-1</span> info has free information about more than 7000 health, community, and social services.
                </p>
            </div>
        </div>
    );
}
